import React from "react";

export default class MessageLog extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            fadeTimeout: null,
        };
    }

    componentWillReceiveProps (props) {
        if (props.messages !== this.props.messages) {
            this.show();
        }
    }

    componentWillUnmount () {
        if (this.state.fadeTimeout !== null) {
            clearTimeout(this.state.fadeTimeout);
        }
    }

    show () {
        if (this.state.fadeTimeout !== null) {
            clearTimeout(this.state.fadeTimeout);
        }
        this.setState({
            fadeTimeout: setTimeout(() => this.setState({fadeTimeout: null}), this.props.fadeTimer)
        });
    }

    render () {

        if (this.props.messages.length === 0) {
            return null;
        }

        const lastMessage = this.props.messages.length - 1;
        const messages = this.props.messages.map((msg, idx) => (
            <div key={msg.msg + msg.timestamp.getTime()} style={{
                color: msg.error ? "red" : "white",
                fontWeight: idx === lastMessage ? "bold" : "normal"
            }}>
                {msg.msg}
            </div>
        ));
        messages.reverse();

        return (
            <div className="transparent-black-bg message-log" style={{
                width: this.props.width,
                maxHeight: this.props.height,
                padding: "4px",
                overflowY: "auto",
                fontSize: this.props.fontSize,
                borderBottomRightRadius: "8px",
                borderBottomLeftRadius: "8px",
                opacity: this.state.fadeTimeout === null ? 0 : 1,
            }}>
                {messages}
            </div>
        );
    }
}

MessageLog.defaultProps = {
    width: "200px",
    height: "100px",
    fontSize: "14px",
    fadeTimer: 10000,
};



// WEBPACK FOOTER //
// ./src/js/MessageLog.js